export class QuotationLine {
    id: string;
    quotationId: string;
    title: string;
    price: string;
    discount: string;
    total: string;
    details: string;

    constructor() {
        this.id = '';
        this.title = '';
        this.price = '';
        this.details = '';
        this.discount = '';
        this.total = '';
    }
}
